import * as React from "react";
import { SVGProps, memo } from "react";

const SvgSearchGreen = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.032 14.014a6.742 6.742 0 1 1 1.037-1.069l3.713 3.713a.745.745 0 1 1-1.053 1.053l-3.697-3.697Zm.952-5.201a5.242 5.242 0 1 1-10.484 0 5.242 5.242 0 0 1 10.484 0Z"
      fill="#2BA168"
    />
  </svg>
);

const Memo = memo(SvgSearchGreen);

export default Memo;
